import axiosInstance from '../utils/axiosConfig';

// VAPID public key - this should match the one in your backend
const VAPID_PUBLIC_KEY = 'BDJL4w6wty9F3gjUnbjmk70syDBUsWxGxNDa35iox83ZR_7ptoHpvl33ZOyPzNa3RVb-znOj-JoNu43Gj_JX1Fg';

// Check if push notifications are supported
export const isPushSupported = () => {
  return 'serviceWorker' in navigator && 'PushManager' in window;
};

// Check if notifications are permitted
export const isNotificationsPermitted = () => {
  return Notification.permission === 'granted';
};

// Request notification permission
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
};

// Subscribe to push notifications
export const subscribeToPushNotifications = async () => {
  try {
    console.log('Starting push notification subscription process');
    console.log('VAPID Public Key:', VAPID_PUBLIC_KEY);
    
    // Check if service worker is supported
    if (!('serviceWorker' in navigator)) {
      console.error('Service workers are not supported');
      return false;
    }

    // Check if push manager is supported
    if (!('PushManager' in window)) {
      console.error('Push notifications are not supported');
      return false;
    }

    // Register service worker
    console.log('Registering service worker...');
    const registration = await navigator.serviceWorker.register('/service-worker.js');
    console.log('Service Worker registered successfully:', registration);

    // Wait for the service worker to be active
    console.log('Waiting for service worker to be active...');
    await navigator.serviceWorker.ready;
    console.log('Service Worker is now active');

    // Check if we already have a subscription
    const existingSubscription = await registration.pushManager.getSubscription();
    if (existingSubscription) {
      console.log('Found existing subscription:', existingSubscription);
      console.log('Unsubscribing from existing subscription...');
      await existingSubscription.unsubscribe();
      console.log('Successfully unsubscribed from existing subscription');
    }

    // Subscribe to push notifications
    console.log('Subscribing to push notifications...');
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
    });
    console.log('Push subscription created:', subscription);

    // Send subscription to server
    console.log('Sending subscription to server...');
    const response = await axiosInstance.post('/push/subscribe', { subscription });
    console.log('Server response:', response.data);

    if (response.status !== 201) {
      throw new Error('Failed to save subscription');
    }

    return true;
  } catch (error) {
    console.error('Error in subscribeToPushNotifications:', error);
    console.error('Error details:', {
      name: error.name,
      message: error.message,
      stack: error.stack
    });
    if (error.name === 'NotAllowedError') {
      console.error('Push notifications are not allowed');
    } else if (error.name === 'AbortError') {
      console.error('Subscription was aborted');
    } else if (error.name === 'InvalidStateError') {
      console.error('Invalid subscription state');
    } else if (error.name === 'SecurityError') {
      console.error('Security error in subscription');
    }
    return false;
  }
};

// Unsubscribe from push notifications
export const unsubscribeFromPushNotifications = async () => {
  try {
    console.log('Starting push notification unsubscribe process');
    const registration = await navigator.serviceWorker.ready;
    console.log('Service Worker ready:', registration);
    
    const subscription = await registration.pushManager.getSubscription();
    console.log('Current subscription:', subscription);
    
    if (subscription) {
      console.log('Sending unsubscribe request to server...');
      const response = await axiosInstance.post('/push/unsubscribe', { subscription });
      console.log('Server response:', response.data);

      if (response.status !== 200) {
        throw new Error('Failed to delete subscription');
      }

      console.log('Unsubscribing from push service...');
      await subscription.unsubscribe();
      console.log('Successfully unsubscribed from push service');
    } else {
      console.log('No active subscription found');
    }
    
    return true;
  } catch (error) {
    console.error('Error unsubscribing from push notifications:', error);
    console.error('Error details:', {
      name: error.name,
      message: error.message,
      stack: error.stack
    });
    return false;
  }
};

// Helper function to convert VAPID public key
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
